import { HttpInterceptorFn } from '@angular/common/http';
import { GeneralService } from '../services/general.service';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  let generalService = inject(GeneralService);
  const router = inject(Router);
  const token: any = generalService.getToken() || '';
  // console.log('interceptor', token)
  // const toast = new Notyf({ position: { x: 'right', y: 'top' } });
  if (typeof token === 'string' && token !== '') {
    const authReq = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + token),
    });
    return next(authReq).pipe(
      catchError((error) => {
        if (error.status === 403) {
          // toast.error('Session expired');
          router.navigate(['/login']);
        }
        // Pass the error to the caller
        return throwError(() => error);
      })
    );
  }

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 403) {
        // Redirect to login page
        // toast.error('Session expired');
        router.navigate(['/login']);
      }
      // Pass the error to the caller
      return throwError(() => error);
    })
  );
};